import Campaign from 'assets/img/svg/Campaign'
import Sale from 'assets/img/svg/Sale'
import React from 'react'
import useSWR from 'swr'

export default function PromoHeader({name}) {
  const { data: credit } = useSWR("/accounts/balances")

  console.log('Credit balance', credit)

  return (
    <div className="w-full p-8 flex item-center mb-10 bg-white rounded-lg shadow-lg">
      <div className="grow">
        <label className="font-bold text-2xl uppercase block mb1">NGN { (credit?.data.filter(data => data.type === 'credit')[0])?.balance }.00</label>
        <span className="text-sm">Credit balance</span>
      </div>

      <div className="rounded-full p-5 bg-success bg-opacity-10">
        {
          name === 'campaign' ? (
            <Campaign classList="m-auto w-8 h-8" />
          ) : (
            <Sale classList="m-auto w-8 h-8" />
          )
        }
      </div>
    </div>
  )
}
